import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { Router, ActivatedRoute } from '@angular/router';
import { pages } from '../../alv-enums';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnChanges {
	@Input() private registerId: number;
	@Input() private kioskId: number;

	@Input() private currentPage: pages;

	public cancelOrderHide = false;

	/** This is here to allow the html code to access the pages enum. */
	public pagesEnum: any;

	constructor(private router: Router
		, public storeService: StoreService
		, private activatedRoute: ActivatedRoute) {
		this.pagesEnum = pages;
	}

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		const self = this;

		if (self.currentPage === self.pagesEnum.ThankYou || self.currentPage === self.pagesEnum.Receipt) {
			self.cancelOrderHide = true;
			if (self.currentPage === self.pagesEnum.ThankYou) {
				setTimeout(() => {
					self.cancelOrder();
				}, self.storeService.kioskSettings.timerAfterTransactionInSec * 1000);
			}
		} else {
			self.cancelOrderHide = false;
		}
	}

	cancelOrder() {
		const self = this;

		if (self.registerId) {
			if (self.kioskId) {
				self.router.navigate([`/dashboard/${self.registerId}/${self.kioskId}`]);
			} else {
				self.router.navigate([`/dashboard/${self.registerId}`]);
			}
		}
	}

}
